import type { JSX } from "react";

import { cn } from "../../lib/cn.js";
import { FyndLoader } from "../ui/FyndLoader.js";
import { Skeleton } from "../ui/skeleton.js";

export interface LoadingStateProps {
  message?: string;
  variant?: "spinner" | "skeleton";
  /** Skeleton row count when variant="skeleton". Default 3. */
  rows?: number;
  /** Loader size when variant="spinner". Default "md". */
  size?: "sm" | "md" | "lg" | "xl";
  className?: string;
}

export function LoadingState({
  message,
  variant = "spinner",
  rows = 3,
  size = "md",
  className,
}: LoadingStateProps): JSX.Element {
  if (variant === "skeleton") {
    return (
      <div className={cn("space-y-3", className)} role="status" aria-live="polite">
        {Array.from({ length: rows }).map((_, i) => (
          <Skeleton key={i} className="h-12 w-full" />
        ))}
        {message ? <p className="sr-only">{message}</p> : null}
      </div>
    );
  }
  return (
    <FyndLoader
      size={size}
      label={message ?? "Loading…"}
      className={cn("p-6", className)}
    />
  );
}
